import styled from "styled-components";
import Projects from "../components/Projects";
import Seo from "../components/Seo";

const Page = styled.div`
  padding-top: 16px;
`;

const ProjectsPage = ({ openModal, setOpenModal }) => {
  return (
    <Page>
      <Seo
        title="Projects by Saroj Giri | Web, Data, and Computer Vision"
        description="Selected projects by Saroj Giri: Hotel Aagaman, fire detection, a finger-controlled puzzle, a CSV analyzer, and other web apps published on GitHub."
        path="/projects"
      />
      <Projects
        openModal={openModal}
        setOpenModal={setOpenModal}
        intro="These are projects I built and published on GitHub, from hotel and school websites to computer-vision and data tools."
      />
    </Page>
  );
};

export default ProjectsPage;
